module.exports = __webpack_public_path__ + "static/media/Rysunek1.3e5f6d40.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/szatnia/Rysunek1.jpg
// module id = 253
// module chunks = 0